import { ITagSimple, ITagValidation, ITagWithGroup } from '../types';
import { concat, chain } from 'lodash';

const sameTag = (tag1: ITagWithGroup) => (tag2: ITagWithGroup | ITagSimple) =>
  tag1.tagGroup.id === tag2.tagGroup.id && tag1.tagValue === tag2.tagValue;

const copyType = (from: ITagSimple[]) => (to: ITagWithGroup) => {
  const fromItem = from.find(sameTag(to));
  if (fromItem) {
    return {
      ...to,
      type: fromItem.type,
    };
  }
  return to;
};

const getServerValidationWithCurrent = (
  validation: ITagValidation<ITagSimple>,
  current: ITagWithGroup[]
): ITagValidation<ITagWithGroup> => {
  return {
    errors:
      validation.errors.length > 0
        ? current
            .map(copyType(validation.errors))
            .filter(tag => validation.errors.find(sameTag(tag)))
        : [],
    warnings:
      validation.warnings.length > 0
        ? current.filter(tag => validation.warnings.find(sameTag(tag)))
        : [],
  };
};

const getRegexErrors = (tags: ITagWithGroup[]) =>
  tags
    .filter(
      tag =>
        tag.tagGroup.regexMatch && !tag.tagValue.match(tag.tagGroup.regexMatch)
    )
    .map(tag => ({ ...tag, type: 'validation' }));

const getGroupWarnings = (tags: ITagWithGroup[]) => {
  const warnTags = tags.filter(
    tag =>
      tag.tagGroup.allowDuplicateOnItemLevel === 'AllowDuplicateWithWarnings'
  );
  const duplicateGroupIds = chain(warnTags)
    .countBy('tagGroup.id')
    .omitBy(count => count < 2)
    .keys()
    .value();

  return warnTags
    .filter(tag => duplicateGroupIds.includes(String(tag.tagGroup.id)))
    .map(tag => ({ ...tag, type: 'duplicateGroup' }));
};

const joinValidations = (
  serverValidation: ITagValidation<ITagWithGroup>,
  regexErrors: ITagWithGroup[],
  groupWarnings: ITagWithGroup[]
): ITagValidation<ITagWithGroup> => ({
  errors: concat(serverValidation.errors, regexErrors),
  warnings: concat(serverValidation.warnings, groupWarnings),
});

export const validateTags = (
  tags: ITagWithGroup[],
  serverValidation: ITagValidation<ITagSimple>
) => {
  const serverValidationWithCurrent = getServerValidationWithCurrent(
    serverValidation,
    tags
  );
  const regexErrors = getRegexErrors(tags);
  const groupWarnings = getGroupWarnings(tags);
  const validation = joinValidations(
    serverValidationWithCurrent,
    regexErrors,
    groupWarnings
  );
  return {
    hasWarnings:
      serverValidation.warnings.length > 0 &&
      serverValidationWithCurrent.warnings.length ===
        serverValidation.warnings.length,
    validation,
  };
};



// WEBPACK FOOTER //
// ./src/views/Admin/Items/services/validateTags.ts